// extracted by mini-css-extract-plugin
export default {"myButton":"buttons_myButton__3iSML","defaultButton":"buttons_defaultButton__AGVun","greenLightButton":"buttons_greenLightButton__o5ZjZ","blueButton":"buttons_blueButton__-sINP"};